import Link from 'next/link'
import React from 'react'
import s from './../../Header.module.sass'
import IconLogoRestSvg from '@icons/icon-afisha-restaurants-logo.svg'
import IconLogoRestOwnerSvg from '@icons/icon-afisha-restaurants-logo--owner.svg'
import IconLogoTextSvg from '@icons/icon-afisha-logo-text.svg'
import { useAppSelector } from '@app/model/store'
import { useParams } from 'next/navigation'
import { EGG } from '@shared/api/analytics'

const UTM_STR = '?utm_source=restaurants&utm_medium=referral&utm_campaign=headline'
const AFISHA_LINK = 'https://www.afisha.ru/' + UTM_STR

const IconLogoRest = React.forwardRef(function CustomComponent() {
  const params = useParams()
  const storeCurrentCity = useAppSelector((state) => state.global.currentCity)
  const isOwnerLanding = useAppSelector(
    (state) => state.global.currentPage === 'owner_landing' || state.global.currentPage === 'owner_landing_form',
  )

  const slug = storeCurrentCity?.slug || params?.city_slug
  const link = slug ? `/${slug}/restaurants/` : '/'

  const handleClick = () => {
    EGG.header.button_tab_click({ navigation_name: 'logo' })
  }

  return (
    <Link
      href={link}
      className={s[`logo-main-link${isOwnerLanding ? '--owner' : ''}`]}
      replace={true}
      onClick={handleClick}
      scroll={false}>
      {!isOwnerLanding ? (
        <IconLogoRestSvg className={s['logo-main-image']} />
      ) : (
        <IconLogoRestOwnerSvg className={s['logo-main-image-owner']} />
      )}
    </Link>
  )
})

const IconLogoText = React.forwardRef(function CustomComponent() {
  const handleClick = () => {
    EGG.header.button_tab_click({ navigation_name: 'logo' })
  }

  return (
    <a href={AFISHA_LINK} className={s['logo-text-link']} onClick={handleClick}>
      <IconLogoTextSvg className={s['logo-text-image']} />
    </a>
  )
})

export { IconLogoRest, IconLogoText }
